import { takeEvery } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";

function* incrementSaga() {
  console.log("incrementSaga");
}

function* decrementSaga() {
  console.log("decrementSaga");
}

export function* watchLoginSaga() {
  yield takeEvery(increment.type, incrementSaga);
  yield takeEvery(decrement.type, decrementSaga);
}

export const loginSlice = createSlice({
  name: "login",
  initialState: {
    count: 0,
  },
  reducers: {
    increment: (state) => {
      state.count += 1;
    },
    decrement: (state) => {
      state.count -= 1;
    },
  },
});

export const { increment, decrement } = loginSlice.actions;

export default loginSlice.reducer;
